import { debug } from 'util';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CustomValidatorsService } from '../shared/validators.service';

import { ConfigurationService } from '../shared/configuration.service';
import { RegistryService } from '../registry/registry.service';
import { Contribution } from '../track/contribution';
import { Gift } from '../gift/gift';
import { ActivatedRoute } from '@angular/router';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Registry } from '../registry/registry';
import { Settings } from '../settings/settings';
import { Merchant } from '../merchant/merchant.state.store';

@Component({
  selector: 'app-account-personal',
  templateUrl: './account-personal.component.html',
  styleUrls: ['./account-personal.component.scss'],
  providers: [SettingsService]
})
export class AccountPersonalComponent implements OnInit {

  public hitchdForm: FormGroup;
  loaded = false;
  registry: Registry;
  contributions: Contribution[];
  settings: Settings;
  gifts: Gift[];
  merchant: Merchant;
  constructor(
    private _fb: FormBuilder,
    private _validatorService: CustomValidatorsService,
    private _configuration: ConfigurationService,
    private _registryService: RegistryService,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
  ) {

    document.title = 'Account | Hitchd';
   }

  ngOnInit() {
    this._registryService.setScrollY(1);

    this.contributions = this.route.snapshot.data.contributions;
    this.gifts = this.route.snapshot.data.gifts;
    this.registry = this.route.snapshot.data.registry;
    this.settings = this.route.snapshot.data.settings;
    this.merchant = this.route.snapshot.data.merchant;
    if (!this.registry){
      this.registry = this._registryFirebaseService.registry;
    }
    this._registryFirebaseService.getContributions(this.gifts).subscribe(contribution => {
      this.contributions =  contribution;
      this.loaded = true;
    });

  }


  handleLoaded(){


  }

  OnSaved(registryName) {

  }




}











// WEBPACK FOOTER //
// ./src/app/account-personal/account-personal.component.ts